module.exports = __webpack_public_path__ + "static/media/credit-repayment.004c3e3e.svg";